import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Navbar, Filters, Machinery } from "../components"
import Footer from '../components/footer/Footer';

export default function Machines() {
    const [searchParams] = useSearchParams();
    const [isExpanded, setIsExpanded] = useState(false);
    const [activeFiltersCount, setActiveFiltersCount] = useState(0);
    const [filters, setFilters] = useState({
        category: 'all',
        condition: [],
        priceRange: { min: '', max: '' },
        yearRange: { min: '', max: '' },
        hoursRange: { min: '', max: '' },
        brands: []
    });

    // Apply URL parameters to filters on mount and when URL changes
    useEffect(() => {
        const categoryParams = searchParams.getAll('category');
        const subcategoryParam = searchParams.get('subcategory');
        const featuredParam = searchParams.get('featured');

        if (categoryParams.length > 0 || subcategoryParam || featuredParam) {
            setFilters(prevFilters => {
                // Handle multiple category parameters
                let categoryValue = prevFilters.category;
                
                if (subcategoryParam) {
                    categoryValue = subcategoryParam;
                } else if (categoryParams.length > 0) {
                    // If multiple categories, use array; if single, use string or array
                    categoryValue = categoryParams.length === 1 ? categoryParams[0] : categoryParams;
                }
                
                return {
                    ...prevFilters,
                    category: categoryValue,
                    featured: featuredParam === 'true'
                };
            });
        }
    }, [searchParams]);

    return (
        <div>
            <Navbar />
            <Filters 
                filters={filters} 
                setFilters={setFilters} 
                isExpanded={isExpanded} 
                setIsExpanded={setIsExpanded}
                setActiveFiltersCount={setActiveFiltersCount}
            />
            <Machinery 
                filters={filters} 
                setFilters={setFilters}
                isExpanded={isExpanded} 
                setIsExpanded={setIsExpanded}
                activeFiltersCount={activeFiltersCount}
            />
            <Footer />
        </div>
    )
}